import { HierarchyWiseItemsTableRef } from '@components/UI-Components/HierarchyWiseItemsTable/HierarchyWiseItemsTable'
import { ElementRefStore } from '@stores/paginated-hierarchy-items/ElementRefStore'
import { action, observable } from 'mobx'

export class TableElementRefStore extends ElementRefStore {
  @observable.struct tableRef: HierarchyWiseItemsTableRef['tableRef']

  constructor() {
    super()
    this.setRef = this.setRef.bind(this)
  }

  @action
  setRef(ref) {
    super.setRef(ref?.ref)
    this.tableRef = ref?.tableRef
  }
}
